<template>
  <span
    class="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold"
    :class="STATE_CLASS[state]"
    :data-state="state"
    :data-testid="testId"
  >
    <svg viewBox="0 0 24 24" class="h-3.5 w-3.5 shrink-0" fill="currentColor" aria-hidden="true">
      <path :d="STATE_ICON[state]" />
    </svg>
    <slot>{{ PRIORITY_SLA_STATE_LABELS[state] }}</slot>
  </span>
</template>

<script setup lang="ts">
import {
  mdiAlertCircleOutline,
  mdiAlertOutline,
  mdiCheck,
  mdiClockOutline,
  mdiFlash,
  mdiProgressClock
} from '@mdi/js'

import type { PrioritySlaState } from '@/Network/Types/Responses/PriorityPaymentsResponses'

import { PRIORITY_SLA_STATE_LABELS } from '../slaFormat'

withDefaults(defineProps<{ state: PrioritySlaState; testId?: string }>(), {
  testId: 'priority-sla-state-badge'
})

/** Ícone + cor: o estado não depende só da cor (daltonismo). */
const STATE_ICON: Record<PrioritySlaState, string> = {
  OVERDUE: mdiAlertCircleOutline,
  URGENT: mdiFlash,
  ATTENTION: mdiAlertOutline,
  ON_TIME: mdiClockOutline,
  DONE: mdiCheck,
  NOT_STARTED: mdiProgressClock
}

const STATE_CLASS: Record<PrioritySlaState, string> = {
  OVERDUE: 'bg-red-700 text-white',
  URGENT: 'bg-orange-100 text-orange-800',
  ATTENTION: 'bg-amber-100 text-amber-800',
  ON_TIME: 'bg-blue-50 text-blue-700',
  DONE: 'bg-green-50 text-green-700',
  NOT_STARTED: 'border border-dashed border-neutral50/40 bg-white text-neutral50'
}
</script>
